import SharedPropsService, { BUILD_TYPE } from '../SharedPropsService';
export const BASE_URL = {
    [BUILD_TYPE.BORROWER_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_PRODUCTION]: 'https://api.voltmoney.in',
    [BUILD_TYPE.PARTNER_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.PARTNER_PRODUCTION]: 'https://api.voltmoney.in',
    [BUILD_TYPE.PLATFORM_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.PLATFORM_PRODUCTION]: 'https://api.voltmoney.in',
    [BUILD_TYPE.BORROWER_TEST_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_QA_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_LOS_STAGING]: 'https://api.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_LMS_STAGING]: 'https://api.staging.voltmoney.in',
};
export const APP_URL = {
    [BUILD_TYPE.BORROWER_STAGING]: 'https://app.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_PRODUCTION]: 'https://app.voltmoney.in',
    [BUILD_TYPE.PARTNER_STAGING]: 'https://app.staging.voltmoney.in',
    [BUILD_TYPE.PARTNER_PRODUCTION]: 'https://app.voltmoney.in',
    [BUILD_TYPE.PLATFORM_STAGING]: 'https://app.staging.voltmoney.in',
    [BUILD_TYPE.PLATFORM_PRODUCTION]: 'https://app.voltmoney.in',
    [BUILD_TYPE.BORROWER_TEST_STAGING]: 'https://test.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_QA_STAGING]: 'https://qa.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_LOS_STAGING]: 'https://los.staging.voltmoney.in',
    [BUILD_TYPE.BORROWER_LMS_STAGING]: 'https://lms.staging.voltmoney.in',
};
export const amplitudeConfig = {
    [BUILD_TYPE.BORROWER_STAGING]: '0db77c455f0b7518a30b95598a6e5e5b',
    [BUILD_TYPE.BORROWER_TEST_STAGING]: '0db77c455f0b7518a30b95598a6e5e5b',
    [BUILD_TYPE.BORROWER_QA_STAGING]: '0db77c455f0b7518a30b95598a6e5e5b',
    [BUILD_TYPE.BORROWER_LOS_STAGING]: '0db77c455f0b7518a30b95598a6e5e5b',
    [BUILD_TYPE.BORROWER_PRODUCTION]: 'f15bbbe2415bf57272c15694aa4358ec',
    [BUILD_TYPE.BORROWER_LMS_STAGING]: '0db77c455f0b7518a30b95598a6e5e5b',
};
export const partnerAmplitudeConfig = {
    [BUILD_TYPE.PARTNER_STAGING]: 'c7ee428e33f4fcd0493c0e4daa328db7',
    [BUILD_TYPE.PARTNER_PRODUCTION]: 'edc0ae0b093ae59882b52329a70cac70',
};
export const DIGIO_ENVIRONMENT = {
    [BUILD_TYPE.BORROWER_STAGING]: 'sandbox',
    [BUILD_TYPE.BORROWER_TEST_STAGING]: 'sandbox',
    [BUILD_TYPE.BORROWER_QA_STAGING]: 'sandbox',
    [BUILD_TYPE.BORROWER_LOS_STAGING]: 'sandbox',
    [BUILD_TYPE.BORROWER_PRODUCTION]: 'production',
    [BUILD_TYPE.BORROWER_LMS_STAGING]: 'sandbox'
};
export const config = {
    URL: BASE_URL[SharedPropsService.getBuildType()],
    APP_URL: APP_URL[SharedPropsService.getBuildType()],
    DIGIO_ENVIRONMENT: DIGIO_ENVIRONMENT[SharedPropsService.getBuildType()],
    AMPLITUDE_CONFIG: amplitudeConfig[SharedPropsService.getBuildType()],
    PARTNER_AMPLITUDE_CONFIG: partnerAmplitudeConfig[SharedPropsService.getBuildType()]
};
export const StoreKey = {
    isPledgeFirstTime: 'isPledgeFirstTime',
    isLoadedFirstTime: 'is_Loaded_First_Time',
    accessToken: 'access_token',
    refreshToken: 'refresh_token',
    userContext: 'user_context',
    urlWithDate: 'url_with_date',
    UTM_PARAMS: 'UTM_PARAMS',
    APP_PLATFORM: 'APP_PLATFORM',
    Platform_leads: 'Platform_leads',
    PLATFORM_ACTIVE_CUSTOMERS: 'PLATFORM_ACTIVE_CUSTOMERS',
    PLATFORM_LINKED_PARTNERS: 'PLATFORM_LINKED_PARTNERS',
    PLJ_borrowerAccountId: 'PLJ_borrowerAccountId',
    PLATFORM_AUTH_TOKEN: 'platformAuthToken',
    LEAD_TOKEN: 'lead_token',
    U_DATA: 'u_data',
    CONTEXT: 'CONTEXT',
    EXTERNAL_ROUTE: 'external_route',
    SDK_CONFIG: 'SDK_CONFIG',
    APPLICATION_ID: 'application_id',
    ROUTE_ID: 'routeId',
    CGTC_USER_CONTEXT: 'cgtc',
    isConvertedToBorrower: 'isConvertedToBorrower'
};
// Partner's app apis
export const partnerApi = {
    login: `${config.URL}/api/client/auth/requestOtp/`,
    verifyOtp: `${config.URL}/api/client/auth/verifyOtp/`,
    userContext: `${config.URL}/app/partner/user`,
    accountAttributes: `${config.URL}/app/partner/accountAttributes/`,
    customer: `${config.URL}/app/partner/`,
    bavAdd: `${config.URL}/app/borrower/application/bav/add`,
    pledgeLimit: `${config.URL}/app/borrower/application/pledge/limit/`,
    userProfile: `${config.URL}/app/borrower/userProfile/`,
    pledgeInit: `${config.URL}/app/borrower/application/pledge/init`,
    authCAS: `${config.URL}/app/borrower/application/pledge/authCAS`,
    pledgeSave: `${config.URL}/app/borrower/application/pledge/save`,
    referalLink: `${config.URL}/app/partner/referralLink/application/`,
    clientList: `${config.URL}/app/partner/`,
    stepperData: `${config.URL}/app/borrower/application/stepper/`,
    generateLink: `${config.URL}/app/partner/getToken/user/`,
    panValidate: `${config.URL}/app/partner/validate/pan`,
    referralLink: `${config.URL}/app/partner/referralLink/application/`,
    advisorLink: `${config.URL}/app/partner/referralLink/partner/`,
    getPartnerName: `${config.URL}/app/partner/details/refCode/`,
    investorLink: `${config.URL}/app/partner/referralLink/borrower/`,
    getCityDetails: `${config.URL}/util/cities`,
    authv2: `${config.URL}/api/client/partner/auth/v2`,
    accountAttribute: `${config.URL}/app/partner/accountAttributes/`,
    getPartnerTokenFromSso: `${config.URL}/api/client/las/partner/getAuthToken`,
    getLeadAuthtoken: `${config.URL}/app/partner/getToken/lead/`,
    getToken: `${config.URL}/app/partner/getToken/borrower/`,
    getDownloadURL: `${config.URL}/app/partner/payout/`,
    getCustomCollateralList: `${config.URL}/partner/collateral/custom/list`,
    getPresentationMaterialList: `${config.URL}/partner/collateral/presentation/list`,
    getPreviewUrl: `${config.URL}/partner/collateral/customizedCollateral`,
    getPartnerLogoUrl: `${config.URL}/app/partner/logoUploadPath/`,
    getMappedRMDetails: `${config.URL}/app/relationship/manager/partner/`,
    getAllCustomerList: `${config.URL}/app/partner/v2/`,
    getActiveCustomerCount: `${config.URL}/app/partner/v2/`,
    getDownloadSoaContent: `${config.URL}/app/analytics/soa/credit/`,
    getDownloadHoldingContent: `${config.URL}/app/analytics/holding/credit/`,
    verifyLeadsOTPAndCreateAccount: `${config.URL}/app/partner/`,
    registerLeadsTriggerOTP: `${config.URL}/api/client/auth/requestOtp/borrower/`,
    getAllPendingApplicationDetails: `${config.URL}/partnerdashboard/pending/partner/`,
};
export const platformApi = {
    activeCustomers: `${config.URL}/app/pf/customer/completed/`,
    leads: `${config.URL}/app/pf/customer/inprogress/`,
    authLogin: `${config.URL}/api/client/auth/v2`,
    linkedPartners: `${config.URL}/app/pf/platform/partner/v2/`,
    validateToken: `${config.URL}/api/client/validate/token`
};
export const api = {
    login: `${config.URL}/api/client/auth/requestOtp/`,
    logout: `${config.URL}/api/client/logout`,
    loginV2: `${config.URL}/api/client/auth/requestOtp/v2/`,
    verifyOtp: `${config.URL}/api/client/auth/verifyOtp/`,
    panVerify: `${config.URL}/app/borrower/application/kyc/pan/panVerify`,
    getAuthToken: `${config.URL}/api/client/las/customer/getAuthToken`,
    pledgeInit: `${config.URL}/app/borrower/application/pledge/init`,
    getCredentialsForAssetFetch: `${config.URL}/app/borrower/application/asset/fetch/credentials`,
    assetPledgeInit: `${config.URL}/app/borrower/application/asset/pledge/init/otp`,
    assetPledgeVerify: `${config.URL}/app/borrower/application/asset/pledge/verify/otp`,
    authCAS: `${config.URL}/app/borrower/application/pledge/authCAS`,
    userContext: `${config.URL}/app/borrower/user`,
    accountAttributes: `${config.URL}/app/borrower/accountAttributes/`,
    triggerEmailOtp: `${config.URL}/api/client/auth/requestOtp/email`,
    activateAsset: `${config.URL}/app/borrower/application/asset/pledge/activate/`,
    aadharInit: `${config.URL}/app/borrower/application/kyc/aadhaar/init`,
    aadharVerify: `${config.URL}/app/borrower/application/kyc/aadhaar/verify`,
    kycSummaryInit: `${config.URL}/app/borrower/application/kyc/summary/init/`,
    kycSummaryVerify: `${config.URL}/app/borrower/application/kyc/summary/verify/`,
    updateKyc: `${config.URL}/app/borrower/application/creditApplication/add/kyc/`,
    banks: `${config.URL}/util/bankInfo/banks`,
    bav: `${config.URL}/app/borrower/application/bav/`,
    bavVerify: `${config.URL}/app/borrower/application/bav/verify`,
    addBank: `${config.URL}/app/borrower/application/bav/add`,
    bankInfoSearch: `${config.URL}/util/bankInfo/search/`,
    photoInit: `${config.URL}/app/borrower/application/kyc/photo/init`,
    photoVerify: `${config.URL}/app/borrower/application/kyc/photo/verify/v2`,
    pledgeLimit: `${config.URL}/app/borrower/application/pledge/limit/`,
    pledgeCreate: `${config.URL}/app/borrower/application/pledge/create`,
    authPledge: `${config.URL}/app/borrower/application/pledge/authPledge`,
    mandateLink: `${config.URL}/app/borrower/application/mandate/link/`,
    mandateStatus: `${config.URL}/app/borrower/application/mandate/status/`,
    agreementLink: `${config.URL}/app/borrower/application/agreement/link/`,
    agreementStatus: `${config.URL}/app/borrower/application/agreement/status/`,
    approvalCheck: `${config.URL}/app/borrower/application/approval/check/`,
    userProfile: `${config.URL}/app/borrower/userProfile/`,
    lmsDisbursal: `${config.URL}/app/borrower/lms/disbursal/`,
    verifyEmail: `${config.URL}/api/client/auth/verifyOtp/email`,
    lmsDisbursalV2: `${config.URL}/app/borrower/lms/disbursal/v2/`,
    lmsDisbursalVerify: `${config.URL}/app/borrower/lms/disbursal/verifyOTP`,
    repaymentBankAccountDetails: `${config.URL}/app/borrower/lms/repaymentBankAccountsDetails/`,
    processingCharges: `${config.URL}/app/borrower/application/pledge/processingCharges`,
    borrowerApplication: `${config.URL}/app/borrower/application/`,
    additionalDetails: `${config.URL}/app/borrower/application/additionalDetails/`,
    pdfLink: `${config.URL}/app/borrower/lms/transactions/`,
    kycDocument: `${config.URL}/app/borrower/application/kyc/document/`,
    documentValidate: `${config.URL}/app/borrower/application/kyc/document/validate/`,
    pdfEmail: `${config.URL}/app/borrower/lms/transactions/email/`,
    getStepper: `${config.URL}/app/borrower/application/stepper`,
    getAgreementStepper: `${config.URL}/app/borrower/application/agreement/stepper/`,
    getCredit: `${config.URL}/app/borrower/lms/credit`,
    kycDocumentPOA: `${config.URL}/app/borrower/application/kyc/document/poa/`,
    documentValidatePOA: `${config.URL}/app/borrower/application/kyc/document/poa/validate/`,
    kycDocumentPOI: `${config.URL}/app/borrower/application/kyc/document/poi/`,
    documentValidatePOI: `${config.URL}/app/borrower/application/kyc/document/poi/validate/`,
    getListOfDisbursalByCreditId: `${config.URL}/app/borrower/lms/disbursal/credit/`,
    pdfHoldingStatement: `${config.URL}/app/borrower/lms/holdingStatement/email/`,
    savePortfolio: `${config.URL}/app/borrower/application/pledge/save`,
    assignLender: `${config.URL}/app/borrower/application/credit/profile/evaluate`,
    checkRefreshCriteria: `${config.URL}/app/borrower/application/refreshPortfolioRequired/`,
    digioKycInitiateRequest: `${config.URL}/app/borrower/application/kyc/digio/init/`,
    digioKycCheckRequestStatus: `${config.URL}/app/borrower/application/kyc/digio/status/`,
    digioKycCheckRequestStatusOnCallBack: `${config.URL}/app/borrower/application/kyc/digio/status/deep/`,
    digioDocsInitiateRequest: `${config.URL}/app/borrower/application/doc/digio/init/`,
    digioDocsCheckRequestStatus: `${config.URL}/app/borrower/application/doc/digio/status/`,
    digioDocsCheckRequestStatusOnCallBack: `${config.URL}/app/borrower/application/doc/digio/status/deep/`,
    digioMandateInitiateRequest: `${config.URL}/app/borrower/application/mandate/digio/init/`,
    digioMandateCheckRequestStatus: `${config.URL}/app/borrower/application/mandate/digio/status/`,
    digioMandateCheckRequestStatusOnCallBack: `${config.URL}/app/borrower/application/mandate/digio/status/deep/`,
    digioMandateCheckRequestStatusOnCallBackV2: `${config.URL}/app/borrower/application/mandate/digio/status/deep/v2/`,
    getLimitModificationApplicationForAccount: `${config.URL}/app/borrower/creditModification/`,
    getLimitModificationApplicationForAccountV2: `${config.URL}/app/borrower/creditModification/`,
    isLimitModificationAllowed: `${config.URL}/app/borrower/creditModification/allowed/`,
    refreshToken: `${config.URL}/api/client/refresh/token`,
    getBorrowerProfile: `${config.URL}/app/borrower/userProfile/`,
    collectionNew: `${config.URL}/app/borrower/lms/collection/new`,
    userPaymentData: `${config.URL}/app/borrower/lms/collection/`,
    userPaymentStatus: `${config.URL}/app/borrower/lms/collection/deep/`,
    kycDocumentPOAManual: `${config.URL}/app/borrower/application/kyc/documents/poa/manual/`,
    documentValidatePOAManual: `${config.URL}/app/borrower/application/kyc/documents/poa/manual/validate/`,
    kycDocumentPOIManual: `${config.URL}/app/borrower/application/kyc/documents/poi/manual/`,
    documentValidatePOIManual: `${config.URL}/app/borrower/application/kyc/documents/poi/manual/validate/`,
    digioKycInitiateRequestV2: `${config.URL}/app/borrower/application/kyc/documents/digio/init/`,
    digioKycCheckRequestStatusV2: `${config.URL}/app/borrower/application/kyc/documents/digio/status/`,
    digioKycCheckRequestStatusOnCallBackV2: `${config.URL}/app/borrower/application/kyc/documents/digio/status/deep/`,
    coBorrowerDigioKycInitiateRequestV2: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/digio/init/`,
    coBorrowerDigioKycCheckRequestStatusV2: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/digio/status/`,
    coBorrowerDigioKycCheckRequestStatusOnCallBackV2: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/digio/status/deep/`,
    pledgeData: `${config.URL}/app/borrower/application/asset/pledge/details/`,
    getBajajKfsv2: `${config.URL}/app/borrower/application/review/kfs/link/`,
    getKfsStatusv2: `${config.URL}/app/borrower/application/review/kfs/status/`,
    stepperData: `${config.URL}/app/borrower/application/stepper/`,
    fetchPanForCoBorrower: `${config.URL}/app/borrower/application/kyc/pan/fetchPan/coborrower/`,
    verifyPanForCoBorrower: `${config.URL}/app/borrower/application/kyc/pan/panVerify/coborrower`,
    fetchAdditionalDetailsForCoBorrower: `${config.URL}/app/borrower/application/additionalDetails/coBorrower/`,
    submitAdditionalDetailsForCoBorrower: `${config.URL}/app/borrower/application/additionalDetails/coBorrower/`,
    fetchKYCSummaryForCoBorrower: `${config.URL}/app/borrower/application/kyc/summary/init/coBorrower/`,
    verifyKYCSummaryForCoBorrower: `${config.URL}/app/borrower/application/kyc/summary/verify/coBorrower/`,
    coBorrowerKYCDocumentPOAManual: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/poa/manual/`,
    coBorrowerDocumentValidatePOAManual: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/poa/manual/validate/`,
    coBorrowerKYCDocumentPOIManual: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/poi/manual/`,
    coBorrowerDocumentValidatePOIManual: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/poi/manual/validate/`,
    securityAssetConsent: `${config.URL}/app/borrower/securityAssetConsent/`,
    saveSecurityConsent: `${config.URL}/app/borrower/saveConsent/`,
    borrowerPANValidate: `${config.URL}/app/borrower/validate/pan`,
    demoVideos: 'https://v1.nocodeapi.com/voltmoney/google_sheets/gzLsgTYfaIrWVELK?tabId=demo_video',
    userAttributes: `${config.URL}/app/borrower/userAttributes/`,
    RegisterALead: `${config.URL}/app/customer/leads`,
    ConvertALeadToBorrower: `${config.URL}/app/customer/leads/convert/borrower/`,
    MFCentralTriggerOtp: `${config.URL}/app/mfCentral/init`,
    MFCentralTriggerOtpV2: `${config.URL}/app/mfCentral/lead/init`,
    MFCentralVerifyOtp: `${config.URL}/app/mfCentral/verify`,
    MFCentralVerifyOtpV2: `${config.URL}/app/mfCentral/lead/verify`,
    GetToken: `${config.URL}/api/client/auth/requestClientToken`,
    getCustomerLeadsAssetData: `${config.URL}/app/customer/leads/asset/`,
    getCustomerLeadsAssetDataV2: `${config.URL}/app/customer/leads/asset/v2`,
    convertLeadToCustomerV2: `${config.URL}/app/customer/leads/convert/borrower/v2`,
    getTransactionHistory: `${config.URL}/app/borrower/lms/transactions/history/`,
    creditPollingAPI: `${config.URL}/app/borrower/application/check/shallow/creditApproval/`,
    checkCustomerEligibility: `${config.URL}/app/borrower/application/checkCustomerEligibility/`,
    getLenderInfo: `${config.URL}/app/borrower/application/creditApplication/lender/info/`,
    getKfsData: `${config.URL}/app/borrower/application/creditApplication/lender/kfs/`,
    getBajajKfs: `${config.URL}/app/borrower/application/review/kfs/init/`,
    acceptBajajKfs: `${config.URL}/app/borrower/application/review/kfs/accept/`,
    getMandateLink: `${config.URL}/app/borrower/application/tata/mandate/link/`,
    getMandateStatus: `${config.URL}/app/borrower/application/tata/mandate/status/`,
    getMandateStatusV2: `${config.URL}/app/borrower/application/tata/mandate/status/v2/`,
    checkCibilCheck: `${config.URL}/app/borrower/application/cibilCheck/`,
    esignInit: `${config.URL}/app/borrower/application/signdesk/esign/init/`,
    validateEsign: `${config.URL}/app/borrower/application/signdesk/esign/validate/`,
    checkEsignStatus: `${config.URL}/app/borrower/application/signdesk/esign/status/deep/`,
    routeConfigNameMisMatch: `${config.URL}/app/borrower/application/routeConfig`,
    getSupportingDocumentInfoForLender: `${config.URL}/app/borrower/application/creditApplication/lender/supportingDocument/info/`,
    getPresignedUrlForAdditionalDocumentToUpload: `${config.URL}/app/borrower/application/getPreSignedUrl/additionalDocument/upload/`,
    submitSupportDocuments: `${config.URL}/app/borrower/application/creditApplication/mismatch/appeal`,
    resetStepAfterReview: `${config.URL}/app/borrower/application/restart/failed/step/`,
    resetStateLoanRegistration: `${config.URL}/app/borrower/application/override`,
    getStampDutyCharges: `${config.URL}/util/statesForStampDuty/`,
    persistNameMismatch: `${config.URL}/app/borrower/application/persist/mismatch/issue/`,
    getCollateral: `${config.URL}/app/borrower/lms/collateralDetails/`,
    getRevocationByCredit: `${config.URL}/app/borrower/lms/getRevocationByCreditId/status`,
    getRevocationDetails: `${config.URL}/app/borrower/lms/getRevocationDetails/`,
    getPendingDisbursal: `${config.URL}/app/borrower/lms/credit/disbursal/pending/`,
    getPendingStatus: `${config.URL}/app/borrower/lms/getPendingCreditRequestsByCreditId/`,
    createRevocation: `${config.URL}/app/borrower/lms/createRevocation/otp`,
    verifyOtpRevocation: `${config.URL}/app/borrower/lms/createRevocation/verifyOTP`,
    getForeclosureDetails: `${config.URL}/app/borrower/lms/foreclosure/`,
    initForeclosureOtp: `${config.URL}/app/borrower/lms/foreclosure/otp/init/`,
    verifyForeclosureOtp: `${config.URL}/app/borrower/lms/foreclosure/otp/verify/`,
    requestForeclosureCollection: `${config.URL}/app/borrower/lms/collection/new/foreclosure`,
    bajajDigioInit: `${config.URL}/app/borrower/application/kyc/bajaj/init/`,
    bajajDigioStatus: `${config.URL}/app/borrower/application/kyc/bajaj/status/`,
    bajajDigioDeepStatus: `${config.URL}/app/borrower/application/kyc/bajaj/deep/status/`,
    bajajDigioCoBorrowerInit: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/kyc/bajaj/init/`,
    getKYCMode: `${config.URL}/app/borrower/application/kyc/documents/digilocker/mode/`,
    bajajDigioCoBorrowerDeepCheckStatus: `${config.URL}/app/borrower/application/kyc/documents/coBorrower/kyc/bajaj/deep/status/`,
    validateUPI: `${config.URL}/app/borrower/lms/validate/vpa`,
    manageLimitConfig: `${config.URL}/app/borrower/lms/credit/lender/manageLimitConfig/`,
    fetchInitV2: `${config.URL}/app/borrower/application/pledge/v2/init`,
    fetchInitV3: `${config.URL}/app/borrower/application/pledge/init/v3`,
    pledgeInitV2: `${config.URL}/app/borrower/application/asset/pledge/v2/init/otp`,
    isTataMergerEnabled: `${config.URL}/app/borrower/application/tata/merger/enabled/`,
    pledgeCreateV2: `${config.URL}/app/borrower/application/pledge/v2/create`,
    enhanceLimitApplicationDetails: `${config.URL}/app/borrower/application/creditApplication/filter/current/applicationDetails/`,
    currentApplicationDetails: `${config.URL}/app/borrower/application/creditApplication/filter/current/applicationDetails/`,
    enhanceLimitApplicationDetailsV2: `${config.URL}/app/borrower/application/creditApplication/filter/current/applicationDetails/credit/`,
    showEnableLimit: `${config.URL}/app/borrower/application/enable/edit/limit/`,
    showEnableLimitV2: `${config.URL}/app/borrower/application/enable/edit/limit/application/`,
    editLimitRoute: `${config.URL}/app/borrower/application/edit/limit/`,
    getPendingCreditRequest: `${config.URL}/app/borrower/lms/getPendingCreditRequestsByCreditId/`,
    showKYCEdit: `${config.URL}/app/borrower/application/creditApplication/should/show/kycEdit/`,
    getRenewalChargesDetails: `${config.URL}/app/borrower/application/renewal/chargesDetails/`,
    getRenewalChargesDetailsV2: `${config.URL}/app/borrower/application/renewal/chargesDetails/credit/`,
    getOfferSelectionInit: `${config.URL}/app/borrower/application/offer/selection/init/`,
    getOfferSelectionVerify: `${config.URL}/app/borrower/application/offer/selection/verify/`,
    reopenAccount: `${config.URL}/app/borrower/lms/reopen/closed/account/`,
    interestDetails: `${config.URL}/app/borrower/lms/interestCollection/details/`,
    getWithdrawlDetails: `${config.URL}/app/borrower/lms/disbursal/requestDetails`,
    getminAmountDetails: `${config.URL}/app/borrower/lms/disbursal/minAmount/details`,
    getForeclosureInProgress: `${config.URL}/app/borrower/lms/credit/foreclosure/requests/inprogress/`,
    getForeclosureCompleted: `${config.URL}/app/borrower/lms/foreclosure/details/foreclosure/request/account/latest/`,
    mfcCgsDetailedOTPInit: `${config.URL}/app/mfCentral/cgs/lead/init`,
    mfcCgsDetailedOTPValidate: `${config.URL}/app/mfCentral/cgs/lead/verify`,
    mfcCgsDetailPoll: `${config.URL}/app/customer/leads/cgs/leads/data`,
    mfFetchInitV3: `${config.URL}/app/borrower/application/fetch/init/otp/v3`,
    mfAuthCasV2: `${config.URL}/app/borrower/application/fetch/authCAS/v2`,
    getPledgeHistory: `${config.URL}/app/borrower/lms/getAllCreditRequestsByCreditId/`,
    getShortfallDetails: `${config.URL}/app/borrower/shortfall/data`,
    getDocumentsList: `${config.URL}/app/borrower/application/uploadDocuments/init`,
    individualDocInit: `${config.URL}/app/borrower/application/uploadDocuments/upload/`,
    individualDocVerify: `${config.URL}/app/borrower/application/uploadDocuments/verify/`,
    submitAllDocs: `${config.URL}/app/borrower/application/uploadDocuments/submit`,
    retryDocumentUpload: `${config.URL}/app/borrower/application/change/state/progress`,
    kycDigiLockerMode: `${config.URL}/app/borrower/application/kyc/documents/digilocker/init/`,
    kycDigiLockerModeStatus: `${config.URL}/app/borrower/application/kyc/documents/digilocker/status/`,
    platformDetailsApi: `${config.URL}/app/pf/details/`,
    coBorrowerInitV2: `${config.URL}/app/borrower/application/kyc/summary/coBorrower/v2/`,
    switchCoBorrowerId: `${config.URL}/app/borrower/application/kyc/switch/coBorrower/`,
    getTATAKYCURL: `${config.URL}/app/borrower/application/kyc/documents/digilockerUrl/`,
    getWithdrawalFailureRequest: `${config.URL}/app/borrower/lms/getFailedCreditRequestsByCreditId/`,
    dspPaymentCallback: `${config.URL}/app/borrower/lms/collection/deep/`,
    panReset: `${config.URL}/app/borrower/application/kyc/pan/panReset/`,
    processInProgress: `${config.URL}/app/borrower/lms/foreclosure/validationAndDetails/`,
    mandateLinkV3: `${config.URL}/app/borrower/application/agreement/loan/contract/link/`,
    mandateStatusV3: `${config.URL}/app/borrower/application/agreement/loan/contract/status/`,
    dspMandateInitiateRequest: `${config.URL}/app/borrower/application/mandate/digio/init/v2`,
    initKfsTata: `${config.URL}/app/borrower/application/signdesk/esign/kfs-file/init/`,
    pollKfsTata: `${config.URL}/app/borrower/application/signdesk/esign/kfs-file/poll/`,
    foreclosureExcessAmountHandling: `${config.URL}/app/borrower/lms/createForeClosureFromDetails/`,
    getLoanDetails: `${config.URL}/app/borrower/lms/credit/loanDetails/`,
    updateUserDetails: `${config.URL}/user/borrower/account/accountVerify/request/otp/init/`,
    verifyUserMobileDetails: `${config.URL}/user/borrower/account/accountVerify/request/otp/verify`,
    updateNewUserDetails: `${config.URL}/user/borrower/account/updateAccount/request/otp/init`,
    verifyOtpNewuserDetails: `${config.URL}/user/borrower/account/updateAccount/request/otp/verify`,
    getPendingDetailsRequest: `${config.URL}/user/borrower/account/updateAccount/request/borrowerAccount/`,
    getDefaultRTA: `${config.URL}/app/borrower/application/fetch/defaultRTA/`,
    isFromMFCentralFlow: `${config.URL}/app/borrower/application/fetch/enabledRTAFlow/`,
    getMFCentralFunds: `${config.URL}/app/borrower/application/fetch/getMfcFetchSummaryResponseStatus/`,
    getMFCFundsPollar: `${config.URL}/app/borrower/application/fetch/mfc/poller/`,
    generateShareLink: `${config.URL}/app/borrower/application/mfd/link/generate/`,
    mfdSharelinkCustomerDetails: `${config.URL}/api/client/auth/mfd/link/`,
    mfdShareLinkInit: `${config.URL}/api/client/auth/mfd/link/requestOtp/`,
    mfdShareLinkVerify: `${config.URL}/api/client/auth/mfd/link/verifyOtp`,
    initiateForeclosure: `${config.URL}/app/borrower/lms/foreclosure/otp/init/v2`,
    verifyForeclosure: `${config.URL}/app/borrower/lms/foreclosure/otp/verify/v2`,
    cancelForeclosure: `${config.URL}/app/borrower/lms/cancel/foreclosure/request`,
    bookTransfer: `${config.URL}/app/borrower/bookTransfer`,
    switchCredit: `${config.URL}/app/borrower/switchCredit`,
};
